
import { PrintBit } from "../../model/entity/printJobSetting";
import Vue from "vue";
import store from "../../store/shop";
export default Vue.component("SHHeader", {
  components: {
    SHStaffSelectDialog: () => import("./SHStaffSelectDialog.vue"),
    SHPrinterSelectDialog: () => import("./SHPrinterSelectDialog.vue"),
  },
  props: {
    pageTitle: {
      type: String,
      required: true,
    },
    page: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isStaffDialogOpen: false,
      isPrinterDialogOpen: false,
      hasManualPrintRule: false,
    };
  },
  computed: {
    prefix() {
      return this.$route.params.prefix;
    },
    shoppix() {
      return this.$route.params.shoppix;
    },
    isBackIcon(): boolean {
      const backIcon = ["order", "checkQuick", "check", "history", "cart", "printer", "category", "category_group","setting-last_order","soldout_group","soldout_category"];
      if (backIcon.find((item) => item === this.page)) {
        return true;
      }
      return false;
    },
    canUseTakeout(): boolean {
      return store.getters.canUseTakeout;
    },
    staffName(): string {
      return store.state.staff.nickname ? store.state.staff.nickname : "-";
    },
    printerNames() {
      return store.state.printerName;
    },
    takeoutAlert(): string {
      if (store.state.takeoutCount > 0) {
        return "alert";
      }
    },
    takeoutCount(): number {
      return store.state.takeoutCount;
    },
    // 無料化判断が保留中のテーブルセッション数（categoryOptions が1件以上あるもの）
    categoryOptionCount(): number {
      const all = store.state.notificationCategoryOption || {};
      return Object.keys(all).filter((tId) => {
        const notification = (all as any)[tId];
        return notification && notification.categoryOptions && notification.categoryOptions.length > 0;
      }).length;
    },
    // 操作待ち = 開始待ちの飲み放題（無料化判断保留含む）。
    // ODR-1696 でバックエンドのフィルタを緩和し、ホール発注・客注文・過去オーダー有無を問わず
    // 開始待ちは全て notificationCategoryOption（categoryOptionCount）に乗るため、これ一本で被覆する。
    actionPendingCount(): number {
      return this.categoryOptionCount;
    },
    actionPendingAlert(): string {
      return this.actionPendingCount > 0 ? "alert" : "";
    },
    soundOrder(): boolean {
      return store.state.sound.order;
    },
    soundTakeout(): boolean {
      return store.state.sound.takeout;
    },
    soundOn(): boolean {
      return store.state.soundOn;
    },
    stylePrintRule(): string {
      if (this.hasManualPrintRule) {
        return "";
      }
      return "display: none;";
    },
  },
  methods: {
    handleClickToggleSideMenu() {
      this.$emit("toggleSideMenu");
    },
    handleClickDialogOpen() {
      this.isStaffDialogOpen = true;
    },
    handleStaffDialogClose() {
      this.isStaffDialogOpen = false;
    },
    handleClickPrinterDialogOpen() {
      this.isPrinterDialogOpen = true;
    },
    handlePrinterDialogClose() {
      this.isPrinterDialogOpen = false;
    },
    getSettleReceiptPrinterName() {
      return this.printerNames[PrintBit.TYPE_SETTLE_AND_RECEIPT] ? this.printerNames[PrintBit.TYPE_SETTLE_AND_RECEIPT].substr(0, 8) : "-";
    },

    handleClickBackButton() {
      this.$emit('back');
    },
    handleClickTakeoutIcon() {
      this.$router.push(`/${this.prefix}/${this.shoppix}/takeout`);
    },
    handleClickActionPendingIcon() {
      // 操作待ちアイコンのクリック。無料化判断が保留中ならポップアップを開くよう要求し、
      // home 画面へ誘導する（飲み放題の開始待ちはテーブルカードの「開始」ボタンで操作する）。
      // すでに home に居る場合は同一ルートへの push で例外になるため握りつぶす。
      if (this.categoryOptionCount > 0) {
        store.commit("requestOpenCategoryOption");
      }
      this.$router
        .push(`/${this.prefix}/${this.shoppix}/home`)
        .catch(() => {});
    },
    handleSoundOn: function () {
      if (store.state.soundOn === true) {
        store.commit("setSoundOn", false);
        store.commit("setLatestOrder", "0000000000");
        store.commit("setLatestTakeoutOrder", "0000000000");
      } else {
        store.commit("setSoundOn", true);
        store.commit("setLatestOrder", "9999999999");
        store.commit("setLatestTakeoutOrder", "9999999999");
      }
    },
  },
});
